import styles from "./ErrorCard.module.scss";
import config from "../../../config/index";
import { Col, Row } from "react-bootstrap";
import PropTypes from "prop-types";
import * as Analytics from "../../../services/analyticsUtag";
import { useEffect } from "react";

const ErrorCard=({errorMsg, fullWidth})=>{
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  useEffect(()=>{
    if(errorMsg){
      if(fullWidth === 1){
        const heading = errorMsg.heading ? errorMsg.heading + ". " : "";
        const subHeading1 = errorMsg.subHeading1 ? errorMsg.subHeading1 + ". ": "";
        const subHeading2 = errorMsg.subHeading2 ? errorMsg.subHeading2 + ". ": "";
        Analytics.error(`${heading}${subHeading1}${subHeading2}`);
      } else {
        Analytics.error(errorMsg);
      }
    }
  },[]);

  const errorBlock=()=>{
      switch (fullWidth) {
          case 1:
           return <>
            <img src={`${imagePrefix}/assets/images/close-black-icon.svg`}
                      width={66}
                      height={66}/>
            <div className={styles["error-card__heading"]}>{errorMsg && errorMsg.heading ? errorMsg.heading: ''}</div>
            <div className={styles["error-card__subheading"]}>{errorMsg && errorMsg.subHeading1 ? errorMsg.subHeading1: ''}</div>
            <div className={styles["error-card__subheading"]}>{errorMsg && errorMsg.subHeading2 ? errorMsg.subHeading2: ''}</div>
        </>
          default:
            return <Row className={styles["error-card-block"]}>
            <Col className={styles["error-card-image"]} xs = {1} md={1}><img src={`${imagePrefix}/assets/images/close-black-icon.svg`}
                      width={27}
                      height={27}
                    />
            </Col>
            <Col className={styles["error-sub-text"]} xs = {11}md={11}>
            <span>{errorMsg ? errorMsg: ''}</span>
            </Col>
        </Row>
      }

  }
    return errorBlock();
}

ErrorCard.propTypes = {
    errorMsg: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
}
export default ErrorCard;
